import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public static user: any = null;

  private userSubject = new BehaviorSubject<any>(null);
  public user$ = this.userSubject.asObservable();

  private userCache$: Observable<any> | null = null;

  protected endpoint?: string;

  constructor(private apiService: ApiService) {
    this.getUser().subscribe((user: any) => {
      if (
        !(user.data.is_t4b_customer == '1' || user.data.is_t4b_customer == 1)
      ) {
        window.location.href = environment.appUrl;
      }
    });
  }

  public getUser(): Observable<any> {
    if (!this.userCache$) {
      this.userCache$ = this.apiService.get('customer', {}, true).pipe(
        tap((user: any) => {
          AuthService.user = user.data;
          this.userSubject.next(user.data);
        }),
        shareReplay(1),
      );
    }
    return this.userCache$;
  }

  public refreshUser(): Observable<any> {
    this.userCache$ = null;
    return this.getUser();
  }

  public getCurrentUser(): any {
    return this.userSubject.value;
  }
}
